import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { VehicleTaxPlan } from '../lib/types';

export const SET_SELF_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/self/set';
export const SET_PLANNED_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/planned/set';

export const DEL_SELF_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/self/delete';
export const DEL_PLANNED_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/planned/delete';

export type VehicleTaxPlanState = {
  selfVehicles: Map<number, VehicleTaxPlan> | null;
  plannedVehicles: Map<number, VehicleTaxPlan> | null;
};

const initialState: VehicleTaxPlanState = {
  selfVehicles: new Map(),
  plannedVehicles: new Map()
};

const setSelfVehicleTaxPlan = createAction<Map<number, VehicleTaxPlan>>(
  SET_SELF_VEHICLE_TAX_PLAN
);
const setPlannedVehicleTaxPlan = createAction<Map<number, VehicleTaxPlan>>(
  SET_PLANNED_VEHICLE_TAX_PLAN
);
const deleteSelfVehicleTaxPlan = createAction<Map<number, VehicleTaxPlan>>(
  DEL_SELF_VEHICLE_TAX_PLAN
);
const deletePlannedVehicleTaxPlan = createAction<Map<number, VehicleTaxPlan>>(
  DEL_PLANNED_VEHICLE_TAX_PLAN
);

const vehicleTaxPlanSlice = createSlice({
  name: 'vehicleTaxPlan',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(setSelfVehicleTaxPlan, (state, { payload }) => {
        state.selfVehicles = new Map(payload);
      })
      .addCase(setPlannedVehicleTaxPlan, (state, { payload }) => {
        state.plannedVehicles = new Map(payload);
      })
      .addCase(deleteSelfVehicleTaxPlan, (state, { payload }) => {
        state.selfVehicles = new Map(payload);
      })
      .addCase(deletePlannedVehicleTaxPlan, (state, { payload }) => {
        state.plannedVehicles = new Map(payload);
      });
  }
});

export const vehicleTaxPlanActions = {
  setSelf: setSelfVehicleTaxPlan,
  setPlanned: setPlannedVehicleTaxPlan,
  deleteSelf: deleteSelfVehicleTaxPlan,
  deletePlanned: deletePlannedVehicleTaxPlan
};

export const addVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehicleTaxPlanActions.setSelf(vehicleTaxPlan)
      : vehicleTaxPlanActions.setPlanned(vehicleTaxPlan)
  );
};

export const setVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehicleTaxPlanActions.setSelf(vehicleTaxPlan)
      : vehicleTaxPlanActions.setPlanned(vehicleTaxPlan)
  );
};

export const deleteVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch(
    self
      ? vehicleTaxPlanActions.deleteSelf(vehicleTaxPlan)
      : vehicleTaxPlanActions.deletePlanned(vehicleTaxPlan)
  );
};

export default vehicleTaxPlanSlice.reducer;
